@import 'styles/mixins';
@import 'styles/variables';

header.header {
  border-bottom: none;
  padding-bottom: 0;
}

@-webkit-keyframes scaleIn {
  from {
    -webkit-transform: scale(0.1);
  }
  to {
    -webkit-transform: scale(1);
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

@-webkit-keyframes moveLogoTop {
  from {
    top: calc(50% - 20px);
  }
  to {
    top: 65px;
  }
}
@keyframes moveLogoTop {
  from {
    top: calc(50% - 20px);
  }
  to {
    top: 65px;
  }
}

@-webkit-keyframes blinkText {
  from {
    color: var(--dark-90);
  }
  to {
    color: var(--dark-10);
  }
}
@keyframes blinkText {
  from {
    color: var(--dark-90);
  }
  to {
    color: var(--dark-10);
  }
}

@media (min-width: $tabletPortraitMinWidth) {
  .container {
    background: url('https://res.cloudinary.com/almanac/image/upload/v1756993792/blaze_assets/backgrounds/first_time_experience/splashscreen_2_vujfzx.png')
      lightgray 30% / cover no-repeat;
  }
}

.container {
  @include shadow-3;
  @include z-index(heaven);
  position: relative;
  background: url('https://res.cloudinary.com/almanac/image/upload/v1753415626/blaze_assets/backgrounds/first_time_experience/splashscreen_0725_g5u9c7.png')
    lightgray 30% / cover no-repeat;
  inset: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  &.fadeIn {
    @include fadein(1s);
  }

  &.fadeOut {
    @include fadeout(1s);
  }

  .logoAndCompanyName {
    top: calc(50% - 20px);
    -webkit-animation: moveLogoTop 0.5s ease-in 2s 1;
    animation: moveLogoTop 0.5s ease-in 2s 1;
    animation-fill-mode: forwards;

    @include for-tablet-portrait-max {
      svg {
        max-width: 120px;
      }
    }
  }

  .content {
    margin: unset;
    width: 100%;
    max-width: unset;

    .blazeHero {
      max-width: 685px;

      -webkit-animation: scaleIn 0.5s ease-in 0s 1;
      animation: scaleIn 0.5s ease-in 0s 1;

      @include for-tablet-portrait-max {
        max-width: min(685px, 90vw);
      }
    }
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 80%;
  text-align: center;
  gap: 10px;
}

.blink {
  -webkit-animation: blinkText 0.5s ease 0s infinite;
  animation: blinkText 0.5s ease 0s infinite;
  animation-direction: alternate;
}

.textContainer {
  position: absolute;
  width: 100%;
}

.logoAndCompanyName {
  text-align: center;
  position: fixed;
  top: 65px;
  width: 100%;
}

.content {
  margin: 0 auto;
  max-width: 1015px;
  text-align: center;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.headline {
  margin: 0 auto;
  padding: 32px 0;

  @include for-tablet-portrait-max {
    padding: 32px 20px;
  }
}

.info {
  color: var(--neutral-40);
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 146%;
  margin: 0 auto;
  max-width: 582px;

  @include for-tablet-portrait-max {
    font-size: 16px;
    padding: 0px 20px;
  }
}

.spinnerContainer {
  display: inline-flex;
  padding: 10px;
  align-items: center;
  border-radius: 35px;
  background: #f5f5f5;
}

.spinner {
  width: 24px;
  height: 24px;
  > div {
    width: 24px;
    height: 24px;
    &::after {
      background-color: #f5f5f5;
      width: 18px;
      height: 18px;
    }
  }
}

.image {
  padding: 24px 0;
}
